import { mask } from 'remask'

export const formatLicensePlate = (value?: string | null) => value ? mask(value.toUpperCase(), ['SSS SSSS', 'SSS SSSSS']) : ''
